import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetAllLocationBadges = (): UseQueryResult<
  Array<components['schemas']['BadgeRewardDTO']>
> => {
  const get = useTypedApiClient({
    path: '/admin/badgerewards/locationBadges',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/badgerewards/locationBadges'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
